/* ============================================
   Adam — Scroll Fade-in
   assets/adam-animations.js
   ============================================ */

(function () {
  function initFadeIn() {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            setTimeout(function () {
              e.target.classList.add('adam-visible');
            }, 60);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -20px 0px' }
    );
    document.querySelectorAll('.adam-fi, .adam-fi2').forEach(function (el) {
      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();